import axiosInstance from '../../common/axios.service';
import {NOTIFICATION_FILTER, NOTIFICATION_MAIN_FILTER} from './notifications.type';

const notifications = (payload: {
  body?: NOTIFICATION_MAIN_FILTER;
  filters?: NOTIFICATION_FILTER;
}) => {
  return axiosInstance
    .post('usernotification', payload.body, {params: payload.filters})
    .then((response) => {
      return response;
    });
};

const notificationsService = {
  notifications,
};

export default notificationsService;
